import reducers from "./reducers";
import { reducer as form } from "redux-form";

export default {
  app: reducers,
  form
};
